import { Route, Switch } from "react-router-dom";

import {
  AdditionalPurchaseCart,
  AdditionalPurchaseSingle,
  NewPurchaseCart,
  NewPurchaseSingle,
  SipWithPaymentCart,
  SipWithPaymentSingle,
  SipWithoutPaymentCart,
  SipWithoutPaymentSingle,
} from "./index";

const PAYMENT_ROUTES = [
  {
    path: "/payment-options/additional-purchase/cart",
    component: AdditionalPurchaseCart,
  },
  {
    path: "/payment-options/sip-purchase-with-payment/cart",
    component: SipWithPaymentCart,
  },
  {
    path: "/payment-options/new-purchase/cart",
    component: NewPurchaseCart,
  },
  {
    path: "/payment-options/sip-purchase-without-payment/cart",
    component: SipWithoutPaymentCart,
  },
  {
    path: "/payment-options/additional-purchase/single",
    component: AdditionalPurchaseSingle,
  },
  {
    path: "/payment-options/sip-purchase-with-payment/single",
    component: SipWithPaymentSingle,
  },
  {
    path: "/payment-options/new-purchase/single",
    component: NewPurchaseSingle,
  },
  {
    path: "/payment-options/sip-purchase-without-payment/single",
    component: SipWithoutPaymentSingle,
  },
];

export default function Router() {
  return (
    <Switch>
      {PAYMENT_ROUTES.map((route) => (
        <Route {...route} key={route.path} />
      ))}
    </Switch>
  );
}
